import { useContext } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { ListGroupCst, ListGroupItemCst, StyledProfileCard } from '../../components/Cards/StyledCard';
import AppPropsContext from '../../context/appPropsContext';
import TerminierungContext from '../../context/terminierungContext';
import { useLanguage } from '../../hooks/useLanguage';
import { getGenderDE } from '../../utils/pcpUtils';

interface IPersonalDataSummary {
    width?: string;
}

const PersonalDataSummary = (props: IPersonalDataSummary) => {
    const { tmstate } = useContext(TerminierungContext);
    const { apstate } = useContext(AppPropsContext);

    const { t } = useLanguage();

    interface IDataItem {
        label: string;
        data: string;
    }

    const DataItem = (props: IDataItem) => {
        return (
            <ListGroupItemCst>
                <Row>
                    <Col sm={4}>{props.label}</Col>
                    <Col sm={8}>
                        <strong>{props.data}</strong>
                    </Col>
                </Row>
            </ListGroupItemCst>
        );
    };

    const getPlannedStudiesList = () => {
        let studyList = '';

        if (tmstate.personalData.plannedStudies.length > 0) {
            for (let i = 0; i < tmstate.personalData.plannedStudies.length; i++) {
                if (tmstate.personalData.plannedStudies[i].participate === true) {
                    if (i === 0) {
                        studyList = studyList + tmstate.personalData.plannedStudies[i].display;
                    } else {
                        studyList = studyList + ', ' + tmstate.personalData.plannedStudies[i].display;
                    }
                }
            }
        }

        return studyList;
    };

    const ContactPersonSummary = () => {
        return (
            <>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <ListGroupCst variant="flush">
                            <ListGroupItemCst>
                                <Row>
                                    <Col sm={8}>
                                        <strong>
                                            <u>Kontaktperson</u>
                                        </strong>
                                    </Col>
                                </Row>
                            </ListGroupItemCst>
                        </ListGroupCst>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ListGroupCst variant="flush">
                            {tmstate.personalDataContactPerson.firstName?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Vorname')}
                                    data={tmstate.personalDataContactPerson.firstName}
                                />
                            )}
                            {tmstate.personalDataContactPerson.lastName?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Nachname')}
                                    data={tmstate.personalDataContactPerson.lastName}
                                />
                            )}
                            {tmstate.personalDataContactPerson.telephone?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Telefonnummer')}
                                    data={tmstate.personalDataContactPerson.telephone}
                                />
                            )}
                            {tmstate.personalDataContactPerson.email?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'E-Mail')}
                                    data={tmstate.personalDataContactPerson.email}
                                />
                            )}
                            {tmstate.personalDataContactPerson.zip?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Postleitzahl')}
                                    data={tmstate.personalDataContactPerson.zip}
                                />
                            )}
                            {tmstate.personalDataContactPerson.city?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Ort')}
                                    data={tmstate.personalDataContactPerson.city}
                                />
                            )}
                            {tmstate.personalDataContactPerson.street?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Straße')}
                                    data={tmstate.personalDataContactPerson.street}
                                />
                            )}
                            {tmstate.personalDataContactPerson.housenr?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Hausnummer')}
                                    data={tmstate.personalDataContactPerson.housenr}
                                />
                            )}
                            {tmstate.personalDataContactPerson.country?.length > 0 && (
                                <DataItem
                                    label={t('PERSONALDATA', 'Land')}
                                    data={tmstate.personalDataContactPerson.country}
                                />
                            )}
                        </ListGroupCst>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <ListGroupCst variant="flush">
                            <ListGroupItemCst>
                                <Row>
                                    <Col sm={8}>
                                        E-Mails werden an folgende Adresse gesendet:{' '}
                                        <strong>
                                            {tmstate.personalData.email
                                                ? tmstate.personalData.email
                                                : tmstate.personalDataContactPerson.email}
                                        </strong>
                                    </Col>
                                </Row>
                            </ListGroupItemCst>
                        </ListGroupCst>
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <StyledProfileCard
            role="region"
            aria-label="Zusammenfassung ihrer persönlichen Daten"
            style={{ width: props.width ? props.width : '100%', marginBottom: '10px', marginTop: '0px' }}
        >
            <Card.Body style={{ textAlign: 'left' }}>
                <Card.Title aria-hidden>{t('ANMELD', 'Ihre persönlichen Daten')}</Card.Title>
                <Row>
                    <Col style={{ padding: 5 }}>
                        <Row>
                            <Container>
                                <Row>
                                    <Col>
                                        <ListGroupCst variant="flush">
                                            {apstate.RegistrationVisibleFields.academicTitle === true &&
                                                tmstate.personalData.academicTitle?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Titel')}
                                                        data={tmstate.personalData.academicTitle}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.firstName === true &&
                                                tmstate.personalData.firstName?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Vorname')}
                                                        data={tmstate.personalData.firstName}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.lastName === true &&
                                                tmstate.personalData.lastName?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Nachname')}
                                                        data={tmstate.personalData.lastName}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.birthDate === true &&
                                                tmstate.personalData.birthday?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Geburtstag')}
                                                        data={tmstate.personalData.birthday}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.gender === true &&
                                                tmstate.personalData.gender?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Geschlecht')}
                                                        data={getGenderDE(tmstate.personalData.gender)}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.phone === true &&
                                                tmstate.personalData.telephone?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Telefonnummer')}
                                                        data={tmstate.personalData.telephone}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.mobilePhone === true &&
                                                tmstate.personalData.mobilePhone?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Mobil-Telefonnummer')}
                                                        data={tmstate.personalData.mobilePhone}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.email === true &&
                                                tmstate.personalData.email?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'E-Mail')}
                                                        data={tmstate.personalData.email}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.zip === true &&
                                                tmstate.personalData.zip?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Postleitzahl')}
                                                        data={tmstate.personalData.zip}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.city === true &&
                                                tmstate.personalData.city?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Ort')}
                                                        data={tmstate.personalData.city}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.street === true &&
                                                tmstate.personalData.street?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Straße')}
                                                        data={tmstate.personalData.street}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.street === true &&
                                                tmstate.personalData.housenr?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Hausnummer')}
                                                        data={tmstate.personalData.housenr}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.country === true &&
                                                tmstate.personalData.country?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Land')}
                                                        data={tmstate.personalData.country}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.insuranceNr === true &&
                                                tmstate.personalData.insuranceNr?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Versichertennr.')}
                                                        data={tmstate.personalData.insuranceNr}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.insuranceName === true &&
                                                tmstate.personalData.insuranceName?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Krankenkasse')}
                                                        data={tmstate.personalData.insuranceName}
                                                    />
                                                )}
                                            {apstate.RegistrationVisibleFields.language === true &&
                                                tmstate.personalData.language?.length > 0 && (
                                                    <DataItem
                                                        label={t('PERSONALDATA', 'Sprache')}
                                                        data={tmstate.personalData.language}
                                                    />
                                                )}
                                            {tmstate.personalData.plannedStudies?.length > 0 && (
                                                <DataItem
                                                    label={t('PERSONALDATA', 'Gewünschte Studienteilnahmen')}
                                                    data={getPlannedStudiesList()}
                                                />
                                            )}
                                        </ListGroupCst>
                                    </Col>
                                </Row>
                                {tmstate.personalDataContactPerson.lastName?.length > 0 && <ContactPersonSummary />}
                            </Container>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </StyledProfileCard>
    );
};

export default PersonalDataSummary;
